// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interview-verify{padding:24px;background:#fff}.interview-verify .interview-verify-title{color:#1c2438;font-weight:700;font-size:16px;line-height:1;text-align:left;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
